Page.laudos = () => {
	/* Dropdown */
	const wrapper = $('.laudos-v1-history-dropdown')
	wrapper.find('.dropdown-toggle').on('click', () => wrapper.toggleClass('active'));
}
